/**
 * @generated SignedSource<<c05a2d8455cf4a379eb02478673b210e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentAvailability = "AVAILABLE" | "BOOKED" | "UNAVAILABLE" | "%future added value";
export type TalentRole = "COLORIST" | "DIRECTOR" | "DRONE_PILOT" | "EDITOR" | "PHOTOGRAPHER" | "PRODUCER" | "SOUND_ENGINEER" | "VIDEOGRAPHER" | "%future added value";
export type UpdateTalentProfileInput = {
  availability?: TalentAvailability | null | undefined;
  bio?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  dayRate?: number | null | undefined;
  disconnectUser?: boolean | null | undefined;
  facebookPageUrl?: string | null | undefined;
  facebookProfileUrl?: string | null | undefined;
  featured?: boolean | null | undefined;
  headline?: string | null | undefined;
  hourRate?: number | null | undefined;
  imageUrl?: string | null | undefined;
  name?: string | null | undefined;
  portfolioLinks?: ReadonlyArray<PortfolioLinkInput> | null | undefined;
  position?: number | null | undefined;
  published?: boolean | null | undefined;
  roles?: ReadonlyArray<TalentRole> | null | undefined;
  skills?: ReadonlyArray<string> | null | undefined;
  slug?: string | null | undefined;
  talentProfileId: string;
};
export type PortfolioLinkInput = {
  label?: string | null | undefined;
  url: string;
};
export type OpsTalentEditPageUpdateMutation$variables = {
  input: UpdateTalentProfileInput;
};
export type OpsTalentEditPageUpdateMutation$data = {
  readonly updateTalentProfile: {
    readonly talentProfile: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsTalentEditPageUpdateMutation = {
  response: OpsTalentEditPageUpdateMutation$data;
  variables: OpsTalentEditPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTalentProfilePayload",
    "kind": "LinkedField",
    "name": "updateTalentProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talentProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsTalentEditPageUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsTalentEditPageUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b01e5cda9c3be387431610a3009cd637",
    "id": null,
    "metadata": {},
    "name": "OpsTalentEditPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsTalentEditPageUpdateMutation(\n  $input: UpdateTalentProfileInput!\n) {\n  updateTalentProfile(input: $input) {\n    talentProfile {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b08767152b706a4cbee37793327ce290";

export default node;
